import { select, on, scrollTop, getScrollTop, addClass, removeClass } from 'modules/dom'
import throttle from 'lodash.throttle'

const offset = 0
const ACTIVE_CLASS = 'back-to-top--activate'
const wrapper = select('.js-wrapper')
const body = document.body

export default function (el) {
  const toggleBackToTop = () => {
    if (getScrollTop(wrapper) > window.innerHeight) {
      addClass(ACTIVE_CLASS, el)
    } else {
      removeClass(ACTIVE_CLASS, el)
    }
  }

  toggleBackToTop()
  on('scroll', throttle(toggleBackToTop, 300), wrapper)

  on('click', () => {
    scrollTop(offset, undefined, wrapper)
  }, el)
}
